// src/routers/SalesRouter.js
import React from 'react';
import { Redirect, Route } from 'react-router-dom';
import useAuthRole from '../Hooks/useAuthRole'; // ✅ use the role hook (sales OR above)

const SalesRouter = ({ children, ...rest }) => {
  const { user, isLoading, isSalesPlus } = useAuthRole();
  // isSalesPlus === sales OR above (based on ROLE_ORDER)

  if (isLoading) {
    return (
      <div className="spinner-border text-primary" role="status">
        <span className="visually-hidden">Loading...</span>
      </div>
    );
  }

  const isSignedIn = !!user?.email;
  const canAccess = isSignedIn && isSalesPlus;

  return (
    <Route
      {...rest}
      render={({ location }) =>
        canAccess ? (
          children
        ) : (
          <Redirect
            to={{
              pathname: '/',
              state: { from: location },
            }}
          />
        )
      }
    />
  );
};

export default SalesRouter;
 